import { RETURN_BUTTON_TEXT } from "../constants";
import { ButtonWithAnalytics } from "./components/ButtonWithAnalytics";
import { EResult } from "./types";
export var converter = function converter(props) {
  var _props$button, _props$buttonReject$t, _props$buttonReject, _props$title;
  return {
    result: props.result || EResult.Success,
    submitButtonProps: {
      onClick: function onClick(e) {
        var _props$onConfirm;
        e.stopPropagation();
        (_props$onConfirm = props.onConfirm) === null || _props$onConfirm === void 0 || _props$onConfirm.call(props);
      },
      children: (_props$button = props.button) === null || _props$button === void 0 ? void 0 : _props$button.text
    },
    cancelButtonProps: props.buttonReject && {
      onClick: function onClick(e) {
        var _props$onReject;
        e.stopPropagation();
        (_props$onReject = props.onReject) === null || _props$onReject === void 0 || _props$onReject.call(props);
      },
      children: (_props$buttonReject$t = (_props$buttonReject = props.buttonReject) === null || _props$buttonReject === void 0 ? void 0 : _props$buttonReject.text) !== null && _props$buttonReject$t !== void 0 ? _props$buttonReject$t : RETURN_BUTTON_TEXT
    },
    title: (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : '',
    subtitle: props.description,
    Component: ButtonWithAnalytics
  };
};